import { useState } from "react";
import { createContainer } from "unstated-next";
import { AuthService } from "../services/AuthService";
import { Config } from "../config/Config";

const LOCAL_STORAGE_USER_KEY = `${Config.campaignId}-user`;

type User = {
    id?: string;
    token?: string;
    isAuthInvalid: boolean;
};

const getLocalStorageItem = (key: string) => {
    try {
        return localStorage.getItem(key);
    } catch (e) {
        console.log(e);
        return "";
    }
};

const setLocalStorageItem = (key: string, value: string) => {
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        console.log(e);
    }
};

const removeLocalStorageItem = (key: string) => {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.log(e);
    }
};


const useUserContainer = () => {
    const userId = getLocalStorageItem(LOCAL_STORAGE_USER_KEY) || "";
    const [user, setUser] = useState<User>({
        id: userId,
        isAuthInvalid: false,
    });

    const login = async (rawUserId?: string) => {

        let result: any = {};
        if (rawUserId) {
            // 認証およびハッシュ化APIの呼び出し
            result = await AuthService().authentication(rawUserId, true);
        } else {
            // 認証APIの呼び出し
            result = await AuthService().authentication(userId, false);
        }

        setLocalStorageItem(LOCAL_STORAGE_USER_KEY, result.userId);

        // 認証トークンを設定
        user.id = result.userId;
        user.token = result.apiToken;
        setUser({ ...user })
    };

    const logout = () => {
        removeLocalStorageItem(LOCAL_STORAGE_USER_KEY);
        setUser((prevState) => {
            prevState.id = undefined;
            prevState.token = undefined;
            prevState.isAuthInvalid = false;
            return prevState;
        })
    };

    return { user, login, logout };
};

export const UserContainer = createContainer(useUserContainer);
